/* weralis-mobile.js — touch behaviour, 2026-10-09 (IB «да, делай» на превью design/mobile-2026-10-09/). No timers: everything follows the visitor's own scroll or swipe. */
(function () {
  var touch = window.matchMedia && window.matchMedia('(hover:none)').matches;
  var narrow = function () { return window.innerWidth < 750; };

  /* Evening: on touch the step that reaches the middle of the screen lights its own sky.
     Scroll-driven, not a timer (auto-advance was rejected 2026-09-17). */
  function evening() {
    var sec = document.getElementById('winddown');
    if (!sec || !touch) return;
    var moms = [].slice.call(sec.querySelectorAll('.mom'));
    if (!moms.length) return;
    var raf = 0, last = -1;
    function pick() {
      raf = 0;
      var mid = window.innerHeight * 0.5, best = 0, bd = Infinity;
      moms.forEach(function (m, n) {
        var r = m.getBoundingClientRect();
        var d = Math.abs(mid - (r.top + r.height / 2));
        if (d < bd) { bd = d; best = n; }
      });
      if (best !== last) { last = best; sec.dataset.i = String(best); }
    }
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(pick); }, { passive: true });
    pick();
  }

  /* Lightbox: focus the dialog itself, swipe between frames, "2 / 5" counter. */
  function lightbox() {
    var d = document.querySelector('#object-new .wr-lb');
    if (!d) return;
    d.setAttribute('tabindex', '-1');
    var cards = document.querySelectorAll('#object-new .wr-fan .cards button');
    var cap = d.querySelector('figcaption');
    var cnt = document.createElement('span');
    cnt.className = 'wm-count';
    cap && cap.after(cnt);
    function count() {
      var src = d.querySelector('img').getAttribute('src');
      var i = 0;
      cards.forEach(function (c, n) { if (c.dataset.src === src) i = n; });
      cnt.textContent = (i + 1) + ' / ' + cards.length;
    }
    new MutationObserver(count).observe(d.querySelector('img'), { attributes: true, attributeFilter: ['src'] });
    new MutationObserver(function () { if (d.open) { d.focus(); count(); } }).observe(d, { attributes: true, attributeFilter: ['open'] });
    var x0 = null;
    d.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    d.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) < 40) return;
      d.querySelector(dx < 0 ? '.nx' : '.pv').click();
    });
  }

  /* Safety Q&A: on a phone every answer starts closed, the questions are the menu. */
  function safety() {
    if (!narrow()) return;
    document.querySelectorAll('#safety-new .qa details[open]').forEach(function (d) { d.removeAttribute('open'); });
  }

  /* Collection intro clamped to two lines on a phone: always give a way to read the rest. */
  function lede() {
    if (!narrow()) return;
    document.querySelectorAll('.wc-lede').forEach(function (l) {
      var head = l.parentElement;
      if (head.querySelector('.wc-rm')) return;
      var p = l.querySelector('p');
      if (!p || p.scrollHeight <= p.clientHeight + 2) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'wc-rm'; b.textContent = 'Read more';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = l.classList.toggle('open');
        b.setAttribute('aria-expanded', String(open));
        b.textContent = open ? 'Show less' : 'Read more';
      });
      l.after(b);
    });
  }

  function init() { evening(); lightbox(); safety(); lede(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
